import { Table } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import Actions from "../../components/Common/Actions";
import Pagination from "../../components/Common/CommonPagination";
import Deletepopup from "../../components/Modal/Deletepopup";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import DownloadLinkBanner from "./DownloadLinkBanner";
import scroll from "../../assets/webp/scroll.webp";

const DownloadLink = () => {
  const [showDelete, setShowDelete] = useState({ id: "", status: false });
  const [loader, setLoader] = useState(true);

  const [platform, setPlatform] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}store-link/list`,
      initialParams: {},
    });

  const handlePageChange = usePageChange(pagination, setPagination);


  // const handleDelete = useDeleteHandler("store-link", fetchData, setShowDelete);

  const handleDelete = async (id) => {
    try {
      setLoader(true);
      await axios.delete(
        `${process.env.REACT_APP_API_URL}store-link/delete/${id}`
      );
      await fetchData({ category: platform._id });
      setShowDelete({ id: "", status: false });
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (platform?._id) {
      setLoader(true);
      fetchData({ category: platform._id });
    }
  }, [platform, pagination.skip, pagination.limit]);

  const toggleActiveStatus = async (status, id) => {
    await setLoader(true);
    await axios.patch(
      `${process.env.REACT_APP_API_URL}store-link/update/active/${id}`,
      { active: !status }
    );
    fetchData({ category: platform._id });
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "serial",
      render: (_text, _record, index) => index + 1,
      fixed: "left",
    },
    {
      title: "Web Page Name",
      dataIndex: "webpage_name",
      key: "webpage_name",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Date / Time of Last Update",
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: "Page Type",
      dataIndex: "page_type",
      key: "page_type",
    },
    {
      title: "Meta Title",
      dataIndex: "meta_title",
      key: "meta_title",
    },
    {
      title: "Meta Description",
      dataIndex: "meta_description",
      key: "meta_description",
    },
    {
      title: "Meta Keyword",
      dataIndex: "meta_keyword",
      key: "meta_keyword",
      width: "300",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <Actions
            recordActiveStatus={record.active}
            isDelete={true}
            isEdit={true}
            isActive={true}
            onClickEdit={() =>
              navigate(`/app-download-link/${record._id}/edit-download-link`)
            }
            onClickDelete={() =>
              setShowDelete({ id: record._id, status: true })
            }
            onClickActive={() => toggleActiveStatus(record.active, record._id)}
          />
        </>
      ),
    },
  ];
  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <>
      <DownloadLinkBanner setPlatform={setPlatform} />
      {!loader ? (
        <>
          <Table
            bordered
            dataSource={records}
            columns={columns}
            pagination={false}
            rowKey="_id"
            className="mx-3 pt-2 table-scrollable medicineList_table"
            scroll={{ x: "max-content" }}
          />
        </>
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}

      <div className="mt-4 d-flex align-items-center justify-content-between admin-pagination">
        <div className="border border-danger bg-bg-light px-2 py-1 rounded">
          Total {id}: {totalCount}
        </div>
        {totalCount > pagination.limit && (
          <Pagination
            skip={pagination.skip}
            limit={pagination.limit}
            total={totalCount}
            onPageChange={(selected) => handlePageChange({ selected })}
          />
        )}
      </div>
      {showDelete.status && (
        <Deletepopup
          handleDelete={handleDelete}
          id={showDelete?.id}
          isCloseModalEnable={true}
          handleClose={() => setShowDelete({ id: "", status: false })}
        />
      )}
    </>
  );
};

export default DownloadLink;
